import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { collection, query, getDocs, where } from 'firebase/firestore';
import { db } from '../../../config/firebase';
import { useAuth } from '../../../context/AuthContext';
import { FaPlus, FaEdit, FaRobot } from 'react-icons/fa';

function EditorAutomationList() {
  const [automations, setAutomations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    fetchAutomations();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const fetchAutomations = async () => {
    try {
      let q;
      if (user.role === 'editor') {
        // Editör sadece kendi otomasyonlarını görebilir
        q = query(
          collection(db, 'automations'),
          where('authorId', '==', user.uid)
        );
      } else {
        // Admin tüm otomasyonları görebilir
        q = query(collection(db, 'automations'));
      }

      const querySnapshot = await getDocs(q);
      const automationList = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setAutomations(automationList);
    } catch (err) {
      console.error('Otomasyonlar yüklenirken hata:', err);
      setError('Otomasyonlar yüklenirken bir hata oluştu');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-red-600 bg-red-100 rounded-lg">
        {error}
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Otomasyonlar</h1>
        <Link
          to="/editor/automations/new"
          className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          <FaPlus className="mr-2" />
          Yeni Otomasyon
        </Link>
      </div>

      {automations.length === 0 ? (
        <div className="text-center py-12">
          <FaRobot className="mx-auto h-12 w-12 text-gray-400" />
          <h3 className="mt-2 text-sm font-medium text-gray-900">Otomasyon Bulunamadı</h3>
          <p className="mt-1 text-sm text-gray-500">
            Henüz hiç otomasyon eklenmemiş.
          </p>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {automations.map((automation) => (
            <div
              key={automation.id}
              className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow border border-gray-200"
            >
              <div className="p-6">
                <h2 className="text-xl font-semibold text-gray-900 mb-2">
                  {automation.title}
                </h2>
                <p className="text-gray-600 mb-4 line-clamp-2">
                  {automation.description}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-sm text-gray-500">
                    {new Date(automation.createdAt?.toDate()).toLocaleDateString('tr-TR')}
                  </span>
                  <Link
                    to={`/editor/automations/edit/${automation.id}`}
                    className="inline-flex items-center text-blue-600 hover:text-blue-800"
                  >
                    <FaEdit className="mr-1" />
                    Düzenle
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default EditorAutomationList; 